import api from 'lib/trpcClient';
import { usePaginatedFilters } from 'further-ui/hooks';
import { SortOrder } from 'further-types/utils';

export default function useListCompanies(pageId: string, vehicleId: string) {
  const { pagination, filters, handleChangeFilters } = usePaginatedFilters(
    pageId,
    {
      defaultFilters: {
        searchQuery: '',
      },
      defaultOrder: {
        orderBy: 'name',
        order: SortOrder.Asc,
      },
    },
  );

  const { data, isFetching } = api.lpCompany.list.useQuery({
    vehicleId,
    ...pagination,
    searchQuery: filters.searchQuery,
  });

  const companyRows = (data?.results ?? []).map((company) => ({
    id: company._id,
    ...company,
  }));

  return {
    companies: companyRows,
    totalCount: data?.totalCount ?? 0,
    isFetching,
    filters,
    handleChangeFilters,
    pagination,
  };
}
